import { decodeBase64Url, encodeBase64Url } from './primitives';

const VAULT_KEY_STORAGE = 'shareweb:vaultKey';
const USER_PRIV_STORAGE = 'shareweb:userPriv';

export function storeVaultSession(vaultKey: Uint8Array, userPrivateKey: Uint8Array): void {
  sessionStorage.setItem(VAULT_KEY_STORAGE, encodeBase64Url(vaultKey));
  sessionStorage.setItem(USER_PRIV_STORAGE, encodeBase64Url(userPrivateKey));
}

export function clearVaultSession(): void {
  sessionStorage.removeItem(VAULT_KEY_STORAGE);
  sessionStorage.removeItem(USER_PRIV_STORAGE);
}

export function hasVaultSession(): boolean {
  return (
    sessionStorage.getItem(VAULT_KEY_STORAGE) !== null &&
    sessionStorage.getItem(USER_PRIV_STORAGE) !== null
  );
}

export function loadVaultSession(): { vaultKey: Uint8Array; userPrivateKey: Uint8Array } | null {
  const vaultKeyValue = sessionStorage.getItem(VAULT_KEY_STORAGE);
  const userPrivValue = sessionStorage.getItem(USER_PRIV_STORAGE);
  if (!vaultKeyValue || !userPrivValue) {
    return null;
  }

  return {
    vaultKey: decodeBase64Url(vaultKeyValue),
    userPrivateKey: decodeBase64Url(userPrivValue),
  };
}
